import track1 from '../assets/audio/home.mp3';
import track2 from '../assets/audio/home2.mp3';
import track3 from '../assets/audio/home3.mp3';
import track4 from '../assets/audio/home4.mp3';

/**
 * Global background music playlist (cycles in order, loops back to the first track).
 * Add a new `import` above and push the URL here to extend the rotation.
 */
export const BGM_PLAYLIST: readonly string[] = [track1, track2, track3, track4];
